export default __webpack_public_path__ + "static/media/Letters1_15.82311449.png";